import { Row, Col, Button } from "react-bootstrap";

const ExcercisesResumeRow = ({title, reps, thumbnail}) => {
  return (
    <Row>
      <Col className="">
        <div className="program-card rounded shadow mb-4 p-3 ">
          <Row>
            <Col md={2}>
              <img src={thumbnail} alt="img" className="img-fluid rounded" />
            </Col>
            <Col md={8} className="d-flex justify-content-center flex-column">
              <h5>{title}</h5>
            </Col>
            <Col md={2} className="d-flex justify-content-center flex-column text-end">
              <p className="mb-0">{reps} reps</p>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default ExcercisesResumeRow;
